<template>
    <div>
        <el-row>
            <el-col :span="3">

                <el-table id="table" size="small" :data="tableList" highlight-current-row v-loading="loading" border
                    stripe element-loading-text="拼命加载中" style="width: 100%" height="800px" @row-dblclick="dbclickTable">

                    <el-table-column align="left" prop="table" label="字段" header-align="center" min-width="150px"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="overHidden">
                                {{ scope.row.table != "" ? scope.row.table : "--" }}
                            </div>
                        </template>
                    </el-table-column>

                </el-table>

            </el-col>

            <el-col :span="21">

                <el-form :inline="true" :model="formInline" ref="formInline" class="user-search" size="small"
                    label-width="90px">

                    <el-form-item label="" prop=" " style="width: 1000px;">
                        <el-input size="small" v-model="formInline.search" @input="inputVal" placeholder="请输入查询内容"
                            style="width: 100%">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="searchData()">查询</el-button>
                        <el-button size="small" type="primary" @click="updateData()">执行</el-button>
                    </el-form-item>

                </el-form>


                <el-table id="table" size="small" :data="dataList" highlight-current-row v-loading="loading2" border
                    stripe element-loading-text="拼命加载中" style="width: 98%" height="700px">

                    <!-- 双层循环 -->
                    <el-table-column align="center" header-align="center" min-width="120px" show-overflow-tooltip
                        v-for="(value, key) in List" :label="key" :key="key" :prop="key">
                        <template slot-scope="scope">
                            <div class="overHidden">
                                {{ scope.row[key] != null ? scope.row[key] : "--" }}
                            </div>
                        </template>
                    </el-table-column>

                </el-table>





            </el-col>
        </el-row>
    </div>
</template>
<script>
import { getTableList, searchSQL, updateSQL } from "../../api/userMG";
export default {

    data() {
        return {
            tableList: [],
            loading: false,

            formInline: {
                search: "",
            },

            List: [],
            dataList: [],
            loading2: false,

            rowAll: "",

        };
    },
    mounted() {
        this.initTable();
    },
    methods: {
        // 初始化左侧数据
        initTable() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                timeStamp: timestamp,
            };
            that.loading = true;
            getTableList(params).then((res) => {
                that.loading = false;
                if (res.data.code == 200) {
                    that.tableList = res.data.data;
                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            });
        },

        // 双击左侧table给右侧input赋值
        dbclickTable(row, column, event) {
            let that = this;
            that.rowAll = row;
            that.formInline.search = "select top 10 * from " + row.table;
            that.searchData();
        },

        // 输入框不能输入回车和双引号
        inputVal(event) {
            const temp = this.formInline.search.replace(/\t/g, '\n');
            let isEnter = this.formInline.search.slice(-1) === '\n';
            const hasDataLine = temp.split('\n').filter(Boolean);
            // 防止第一行空行回车放行
            if (hasDataLine.length === 0) {
                isEnter = false;
            }
            this.formInline.search = `${hasDataLine.join('\n')}${isEnter ? '\n' : ''}`;

            if (this.formInline.search.includes('"')) {
                this.formInline.search = event.replace('"', '');
            }

        },

        // 搜索数据
        searchData() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "strSQL": that.formInline.search,
                "timeStamp": timestamp,
            };
            that.loading2 = true;
            searchSQL(params).then((res) => {
                that.loading2 = false;
                if (res.data.code == 200) {
                    that.dataList = res.data.data;
                    that.List = res.data.data[0];

                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            });
        },
        // 更新数据
        updateData() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let params = {
                "strSQL": that.formInline.search,
                "timeStamp": timestamp,
            };
            that.loading2 = true;
            updateSQL(params).then((res) => {
                that.loading2 = false;
                if (res.data.code == 200) {
                    that.dataList = res.data.data;
                    that.List = res.data.data[0];

                    that.$message({
                        type: "success",
                        message: res.data.message,
                    });
                } else {
                    that.$message({
                        type: "error",
                        message: res.data.message,
                    });
                }
            });

        },

    },
};
</script>

<style lang="less" scoped>
/deep/ .el-table th {
    background-color: #1b4283;
}

/deep/ .el-form-item__content {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/admin666/cloudManage.vue